import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty, IsBoolean } from 'class-validator';
import { ApiHideProperty, ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Transform } from 'class-transformer';

export class PostDTO {
  @ApiProperty()
  @ApiPropertyOptional()
  Id?: number;
  @ApiProperty()
  @MaxLength(1000, { message: "Text allows maximum 1000 characters" })
  @IsNotEmpty({message:"Text should not be empty"})  
  text:string;
  @ApiProperty()
  @ApiPropertyOptional()
  isDevelopmentPost:number;
  @ApiProperty()
  @ApiPropertyOptional()
  developStatus:string;
  @ApiProperty()
  @ApiPropertyOptional()
  location?:string;
  @ApiProperty()
  @ApiPropertyOptional()
  villageId?:number;
  @ApiProperty()
  @ApiPropertyOptional()
  viewCount?:string;
  @ApiProperty()
  @IsNotEmpty({message:"Post type should not be empty"})
  postTypeId:number;
  @ApiProperty()
  @IsNotEmpty({message:"Post category should not be empty"})
  postCategoryId:number;
  @ApiProperty()
  imgLocation:string;
  @ApiProperty()
  status: number;
  isPinned:boolean;
  pinDate:Date;
  pinnedBy:number;
  createdAt : Date;
  @ApiProperty()
  @ApiPropertyOptional()
  createdUser : number;
  @ApiProperty()
  @ApiPropertyOptional()
  userId: number;
  @ApiProperty()
  @ApiPropertyOptional()
  pollExpire:Date;
  updatedAt : Date;
  @ApiProperty()
  @ApiPropertyOptional()
  updatedUser : number;
  @ApiProperty()
  @ApiPropertyOptional()
  versionFlag : number;
  @ApiProperty({ type: 'array', items: { type: 'string' } })
  @ApiPropertyOptional()
  pollOptions?: any[];
  @ApiProperty({ type: 'array', items: { type: 'string', format: 'binary' } })
  @ApiPropertyOptional()
  attachments?: any[];
}


export class PaginationDto {
  @ApiProperty()
  apiVersion?:number;
  @ApiProperty()
  skip:number;
  @ApiProperty()
  type?:number;
  @ApiProperty()
  @ApiPropertyOptional()
  villageId?:number;
  @ApiProperty()
  @ApiPropertyOptional()
  filterId?:number;
  @ApiProperty()
  @ApiPropertyOptional()
  categoryId:number;
  @ApiProperty()
  @ApiPropertyOptional()
  year?:number;
}

export class Pagination1Dto {
  @ApiProperty()
  apiVersion?:number;
  @ApiProperty()
  skip:number;
  @ApiProperty()
  lastPostId:number;
}

export class Pagination2Dto {
  @ApiProperty()
  apiVersion?:number;
  @ApiProperty()
  skip:number;
  @ApiProperty()
  type:number;
}


export class PinPostDto {
  @ApiProperty()
  postId:number;
  @ApiProperty()
  isPinned:boolean;
  @ApiProperty()
  userId:number;
}

export class PostApprvDto {
  @ApiProperty()
  postId:number;
  @ApiProperty()
  status:number;
}

export class GSearchDto {
  @ApiProperty()
  searchTerm:string;
}


export class PostDeleteDto {
  @ApiProperty()
  postId:number;
  @ApiProperty()
  status:number;
  @ApiProperty()
  updatedUser : number;
}


export class PercentDto {
  @ApiProperty()
  @ApiPropertyOptional()
  villageId?:number;
}
